import axios from 'axios';
import env from '../../config';

export const lessonRescheduleReject = async (
	{ lessonId }: { lessonId: string }
): Promise<void> => {
	await axios.post(env.endpoints.lessonRescheduleReject, {
		lessonId,
	}, {
		headers: {
			'Content-Type': 'application/json',
		},
	})
	return ;

};
